(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["portable-carousel"] && !Shopify.designMode) return;
  try {
    class PortableCarousel {
    constructor(element) {
      this.element = element;
      this.viewport = element.querySelector('[data-portable-carousel-viewport]');
      this.slides = Array.from(element.querySelectorAll('[data-portable-carousel-slide]'));
      this.dots = Array.from(element.querySelectorAll('[data-portable-carousel-dot]'));
      this.indicatorShapes = Array.from(element.querySelectorAll('[data-portable-carousel-indicator-shape]'));
      this.previous = element.querySelector('[data-portable-carousel-prev]');
      this.next = element.querySelector('[data-portable-carousel-next]');
      this.wraparound = element.dataset.wraparound !== 'false';
      this.index = 0;
      this.isProgrammaticScroll = false;

      if (!this.viewport || this.slides.length === 0) return;

      this.onScroll = this.onScroll.bind(this);
      this.onResize = this.onResize.bind(this);
      this.onScrollEnd = this.onScrollEnd.bind(this);
      this.detectClosestOnNextFrame = this.detectClosestOnNextFrame.bind(this);

      this.previous?.addEventListener('click', () => {
        let previousIndex = this.index - 1;
        if (previousIndex < 0) previousIndex = this.wraparound ? this.maxIndex : 0;
        this.goTo(previousIndex);
      });

      this.next?.addEventListener('click', () => {
        let nextIndex = this.index + 1;
        if (nextIndex > this.maxIndex) nextIndex = this.wraparound ? 0 : this.maxIndex;
        this.goTo(nextIndex);
      });

      this.dots.forEach((dot) => {
        const goToDot = (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.goTo(Number(dot.dataset.slideIndex || 0));
        };

        dot.addEventListener('click', goToDot);
        dot.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            goToDot(event);
          }
        });
      });

      this.viewport.addEventListener('scroll', this.onScroll, { passive: true });
      this.viewport.addEventListener('scrollend', this.onScrollEnd);
      window.addEventListener('resize', this.onResize);

      requestAnimationFrame(() => this.goTo(0, 'auto'));
    }

    get maxIndex() {
      return this.slides.length - 1;
    }

    get offset() {
      const viewportWidth = this.viewport.clientWidth;
      const slideWidth = this.slides[0]?.offsetWidth || 0;
      return Math.max(0, (viewportWidth - slideWidth) / 2);
    }

    get maxScrollLeft() {
      return Math.max(0, this.viewport.scrollWidth - this.viewport.clientWidth);
    }

    getTargetLeft(index) {
      const slide = this.slides[index];
      if (!slide) return 0;
      return Math.max(0, Math.min(this.maxScrollLeft, slide.offsetLeft - this.offset));
    }

    goTo(index, behavior = 'smooth') {
      const nextIndex = Math.max(0, Math.min(index, this.maxIndex));
      const left = this.getTargetLeft(nextIndex);
      this.isProgrammaticScroll = behavior === 'smooth';
      this.viewport.scrollTo({ left, behavior });
      this.setActive(nextIndex);

      if (behavior !== 'smooth') {
        this.isProgrammaticScroll = false;
      }
    }

    setActive(index) {
      const previousIndex = this.index;
      const direction = index > previousIndex ? 'next' : 'previous';

      this.index = index;
      this.element.dataset.activeIndex = index;
      this.element.dataset.previousIndex = previousIndex;
      this.element.dataset.carouselDirection = index === previousIndex ? 'initial' : direction;

      this.slides.forEach((slide, slideIndex) => {
        const active = slideIndex === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-current', active ? 'true' : 'false');
      });

      this.dots.forEach((dot, dotIndex) => {
        const active = dotIndex === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      this.indicatorShapes.forEach((shape, shapeIndex) => {
        const active = shapeIndex === index;
        const x = shapeIndex < index ? shapeIndex * 13 : shapeIndex * 13 + (active ? 0 : 21);
        const width = active ? 31 : 10;

        shape.classList.toggle('is-active', active);
        shape.style.setProperty('--portable-carousel-indicator-x', `${x}px`);
        shape.style.setProperty('--portable-carousel-indicator-width', `${width}px`);

        const dot = this.dots[shapeIndex];
        dot?.style.setProperty('--portable-carousel-dot-hit-x', `${x}px`);
        dot?.style.setProperty('--portable-carousel-dot-hit-width', `${width}px`);
      });
    }

    detectClosest() {
      const target = this.viewport.scrollLeft;
      let closestIndex = 0;
      let smallestDistance = Infinity;

      this.slides.forEach((slide, index) => {
        const distance = Math.abs(this.getTargetLeft(index) - target);
        if (distance < smallestDistance) {
          smallestDistance = distance;
          closestIndex = index;
        }
      });

      this.setActive(closestIndex);
    }

    detectClosestOnNextFrame() {
      this.scrollFrame = null;
      this.detectClosest();
    }

    onScroll() {
      window.clearTimeout(this.scrollTimer);
      if (this.scrollFrame) window.cancelAnimationFrame(this.scrollFrame);

      if (this.isProgrammaticScroll) {
        this.scrollTimer = window.setTimeout(() => this.onScrollEnd(), 140);
        return;
      }

      this.scrollFrame = window.requestAnimationFrame(this.detectClosestOnNextFrame);
    }

    onResize() {
      this.goTo(this.index, 'auto');
    }

    onScrollEnd() {
      this.isProgrammaticScroll = false;
      this.detectClosest();
    }
  }

  const initPortableCarousels = (root = document) => {
    root.querySelectorAll('[data-portable-carousel]').forEach((carousel) => {
      if (!carousel.dataset.portableCarouselReady) {
        carousel.dataset.portableCarouselReady = 'true';
        new PortableCarousel(carousel);
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initPortableCarousels(), { once: true });
  } else {
    initPortableCarousels();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initPortableCarousels(event.target);
  });
  } catch(e) { console.error(e); }
})();

})();
